export const meta = {
  id: 'merge-insertion-hybrid',
  name: 'Merge Sort + Insertion Sort Hybrid',
  category: 'Hybrid',
  complexity: {
    time: 'O(n log n)',
    space: 'O(n)'
  },
  description: 'Hybrid sorting algorithm that uses Insertion Sort for small subarrays within Merge Sort to reduce overhead and improve constant factors.'
};
